import React from 'react';
import classnames from 'classnames';
import GeneralImageNew, { IGeneralImageDomain } from '@gp/components/GeneralImageNew';
import CoverName from '@gp/components/CoverUploader/components/CoverName';
import CoverInfo from '@gp/components/CoverUploader/components/CoverInfo';
import CoverBtns, { ICoverBtnsProps } from '@gp/components/CoverUploader/components/CoverBtns';

import type { IBaseProps } from '@home/types/common';
import type { ICover } from '@gp/components/CoverUploader/types';

import './index.scss';

// 组件props类型
interface ICoverCardProps extends IBaseProps, ICoverBtnsProps {
  // domain，比如说user、game、studio，不同的domain有不同的默认图片
  domain?: IGeneralImageDomain;
  // 默认图片，优先级高于domain
  errorImg?: string;
  // 上传进度
  percents?: number;
  // 文件类型、文件大小限制这部分的提示内容
  tips?: string | React.ReactElement;
  // cover的dataURL，用来展示图片
  cover?: string;
  // cover信息
  data?: ICover;
}

const CoverCard: React.FC<ICoverCardProps> = (props) => {
  const {
    style,
    className,
    domain = 'game',
    errorImg,
    status = 'success',
    percents = Number.NaN,
    tips,
    cover,
    data,
    onCancel,
    onUploadAgain,
    onDelete,
  } = props;

  return (
    <div
      style={style}
      className={classnames('dbg-game-overview-message', className, { 'is-error': status === 'error' })}
    >
      <GeneralImageNew
        className="dbg-game-overview-message-img"
        width={100}
        height={100}
        domain={domain}
        errorImg={errorImg}
        src={cover || ''}
      />
      <div className="dbg-game-overview-message-context">
        <div className="dbg-game-overview-message-title">
          <CoverName status={status} percents={percents} name={data?.name} />
          {/* cover的操作按钮 */}
          <CoverBtns
            className="dbg-game-overview-message-right"
            status={status}
            // 取消上传
            onCancel={onCancel}
            // 重新上传
            onUploadAgain={onUploadAgain}
            // 删除
            onDelete={onDelete}
          />
        </div>
        <CoverInfo tips={tips} data={data} />
      </div>
    </div>
  );
};

export default CoverCard;
